import { useEffect, useRef } from "react";

const AUTOSCROLL_THRESHOLD = 500;
const AUTOSCROLL_TIMEOUT = 200;

export const useChatContainerBehavior = ({ messages = null } = {}) => {
  const chatContainerRef = useRef<HTMLDivElement>(null);
  const userScrollDetectedRef = useRef(false);

  useEffect(() => {
    const chatContainer = chatContainerRef.current;
    const isUserScrollDetected = userScrollDetectedRef.current;
    let scrollTimeout: any = null;
    if (chatContainer) {
      const scrollOffset =
        chatContainer.scrollHeight -
        (chatContainer.scrollTop + chatContainer.clientHeight);
      if (!isUserScrollDetected || scrollOffset < AUTOSCROLL_THRESHOLD) {
        scrollTimeout = setTimeout(() => {
          chatContainer.scrollTop = chatContainer.scrollHeight;
        }, AUTOSCROLL_TIMEOUT);
      }
    }

    return () => {
      clearTimeout(scrollTimeout);
    };
  }, [messages]);

  const onScroll = () => {
    userScrollDetectedRef.current = true;
  };

  return { chatContainerRef, onScroll };
};
